import styled from '@emotion/styled';
import { colorToAlpha } from 'helpers/insight';
import { TrianglePosition } from './';

export const Wrapper = styled.div`
  margin-top: 66px;
`;

export const AdditionalInfoList = styled.ul`
  ${({ theme }) => `
    list-style-type: disc;
    margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(2)};
  `}
`;

export const AdditionalInfoItem = styled.li`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 10px;
`;

export const FullRange = styled.div`
  width: 100%;
  height: 12px;
  border-radius: ${({ theme }) => theme.borderRadius.tiny};
  position: relative;
`;

export const LowerPriceEstimatedRange = styled.div<{width: string, isPriceInCurrentRange: boolean}>`
  position: absolute;
  height: 12px;
  width: ${props => `calc(${props.width} - 3px)`};
  border-radius: ${({ theme }) => `${theme.borderRadius.small} ${theme.borderRadius.tiny} ${theme.borderRadius.tiny} ${theme.borderRadius.small}`};
  left: 0;
  background: ${props => props.isPriceInCurrentRange ? 'linear-gradient(to left, #d1dedb, #89cca4)' : props.theme.colors.neutrals.grey9};
`;

export const HigherPriceEstimatedRange = styled.div<{width: string, isPriceInCurrentRange: boolean}>`
  position: absolute;
  width: ${props => `calc(${props.width} - 3px)`};
  border-radius: ${({ theme }) => `${theme.borderRadius.tiny} ${theme.borderRadius.small} ${theme.borderRadius.small} ${theme.borderRadius.tiny}`};
  right: 0;
  height: 12px;
  background: ${props => props.isPriceInCurrentRange ? 'linear-gradient(to right, #f1e2e4, #e36978)' : props.theme.colors.neutrals.grey9};
`;

export const EstimatedRange = styled.div<{ left: string, width: string, gradientPoint: string }>`
  background: linear-gradient(to right, #e3daff 0 10%, ${props => colorToAlpha(props.theme.colors.insights.prices, 0.6)} ${({ gradientPoint }) => gradientPoint}, #e3daff 90% 100%);
  background: #cec2f6;
  position: absolute;
  height: 18px;
  left: ${props => props.left};
  width: ${props => props.width};
  border-radius: ${({ theme }) => theme.borderRadius.tiny};
  height: 12px;
`;

export const EstimatedPoint = styled.div<{ left: string }>`
  position: absolute;
  content: '';
  border-left: dotted 2px ${props => props.theme.colors.insights.prices};
  left: ${({ left }) => left};
  top: -3px;
  height: 17px;
`;

export const Tooltip = styled.div<{ isSpecialColor: boolean, tooltipOffset: number; trianglePosition: number; }>`
  position: absolute;
  border-radius: ${({ theme }) => theme.borderRadius.tiny};
  padding: 4px 9px;
  top: -40px;
  transform: translateX(calc(${({ theme, tooltipOffset }) => theme.isRTL ? `${tooltipOffset}%` : `-${tooltipOffset}%`} ${props => props.theme.isRTL ? '-' : '+'} 6px));
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.isSpecialColor ? props.theme.colors.insights.prices : props.theme.colors.neutrals.white};
  box-shadow: ${props => props.theme.shadow.level2};
  border: solid 1px ${props => props.isSpecialColor ? props.theme.colors.insights.prices : props.theme.colors.neutrals.grey7};

  > div {
    ${props => props.isSpecialColor ? `
      color: ${props.theme.colors.neutrals.white};
      font-weight: bold;
    ` : ''}
  }

  &:after {
    content: '';
    position: absolute;
    ${(props) => {
      switch (props.trianglePosition) {
        case TrianglePosition.START:
        case TrianglePosition.END:
          return `
                transform: translateX(${props.trianglePosition === TrianglePosition.START ? '0' : '-100%'});
                border-right: ${
            props.trianglePosition === TrianglePosition.START ?
              `0 none` :
              `8px solid ${props.isSpecialColor ? props.theme.colors.insights.prices : props.theme.colors.neutrals.grey7}`
            };
                border-left: ${
            props.trianglePosition === TrianglePosition.END ?
              `0 none` :
              `8px solid ${props.isSpecialColor ? props.theme.colors.insights.prices : props.theme.colors.neutrals.grey7}`
            };
                border-top: 10px solid transparent;
                border-bottom: 8px solid transparent;
                left: calc(${props.trianglePosition}% ${props.trianglePosition === TrianglePosition.START ? '-' : '+' } 1px);
                bottom: -8px;
                filter: drop-shadow(3px 4px 6px rgba(0,0,0,0.1));
              `;
        default:
          return `
                transform: translateX(-50%) rotate(45deg);
                width: 8px;
                height: 8px;
                bottom: -5px;
                left: ${props.trianglePosition}%;
                background: ${props.isSpecialColor ? props.theme.colors.insights.prices : props.theme.colors.neutrals.white};
                border-right: solid 1px ${props.isSpecialColor ? props.theme.colors.insights.prices : props.theme.colors.neutrals.grey7};
                border-bottom: solid 1px ${props.isSpecialColor ? props.theme.colors.insights.prices : props.theme.colors.neutrals.grey7};
                box-shadow: 3px 4px 8px 0 rgba(0,0,0,0.1);
              `;
      }
    }}
  }
`;

export const ChartMarkerContainer = styled.div<{ left: string }>`
  position: absolute;
  left: ${({ left }) => left};
  top: 50%;
  padding: 5px;
  transform: translateY(-50%) translateX(-50%);
`;

export const Labels = styled.div`
  color: ${props => props.theme.colors.neutrals.grey3};
  width: 100%;
  position: relative;
  margin-top: 12px;
  > div {
    white-space: nowrap;
    position: absolute;
    transform: translateX(-50%);
  }
`;

export const MiddleLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #373737;
`;
